module.exports = __webpack_public_path__ + "static/media/logo-blue.268777d0.svg";